import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_replenishment_run_supplier_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_run_supplier.model';

export class StockReplenishmentRunFilterSupplierModel extends BaseContainerModel {
  bl_inv_stock_replenishment_run_supplier: bl_inv_stock_replenishment_run_supplier_RowClass = new bl_inv_stock_replenishment_run_supplier_RowClass();
}
